import {useEffect, useState} from 'react';
import {PriceWithFallback} from '../../../common/ui/PriceWithFallback';
import {AddHabitualToCartButton} from '../../../product/ui/AddHabitualToCartButton';
import {isSuccess} from '../../../common/domain/RemoteData.model';
import {fetchHabitualesRetrasados} from '../../../features/catalog/infrastructure/CatalogService';
import {useComercialContext} from '../../../comercial/ComercialContext';
import {useCartContext} from '../../context/CartContext';

/**
 * Aviso discreto en la pagina del carrito con habituales que hace tiempo que no se piden.
 * Sin dias ni frecuencia (decision de negocio). Oculta los que ya estan en el carrito.
 */
export const HabitualesRetrasadosAviso = () => {
  const [items, setItems] = useState([]);
  const {actingAsCliente} = useComercialContext();
  const {isOnCart} = useCartContext();
  const numCliente = actingAsCliente?.numCliente ?? null;

  useEffect(() => {
    let cancelled = false;
    setItems([]);
    fetchHabitualesRetrasados(numCliente).then((result) => {
      if (!cancelled && isSuccess(result) && Array.isArray(result.value)) {
        setItems(result.value);
      }
    });
    return () => { cancelled = true; };
  }, [numCliente]);

  const visibles = items.filter((item) => item?.product && !isOnCart(item.product.id));

  if (visibles.length === 0) {
    return null;
  }

  return (
    <div className="border rounded-3 p-3 mt-4 bg-white" data-testid="habituales-retrasados">
      <h5 className="text-primary mb-1">¿Te falta algo?</h5>
      <p className="text-muted mb-3">Estos productos los pides habitualmente y hace tiempo que no los incluyes:</p>
      <div className="d-flex flex-column gap-2">
        {visibles.map((item) => (
          <div key={item.product.code} className="d-flex align-items-center gap-3 flex-wrap border-top pt-2">
            <img src={item.product.imageUrl}
                 alt="Imagen del producto"
                 style={{height: '48px', width: '48px', objectFit: 'contain'}} />
            <span className="flex-grow-1 fw-bold">{item.product.name}</span>
            <PriceWithFallback data={{
              sellingPrice: item.product.price?.bestPrice,
              basePrice: item.product.price?.value
            }} />
            <div style={{minWidth: '11rem'}}>
              <AddHabitualToCartButton product={item.product} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};